import { IColors, ITheme } from "@swiggy-private/dls-web-common/dist/components/types";

type ThemeOverrides = {
    [K in keyof IColors]?: string;
};

export const generateCustomTheme = (theme: ITheme, overrides: ThemeOverrides): [ITheme, Record<string, string>] => {
    if (Object.keys(theme.colors).length === 0) {
        return [
            theme,
            Object.entries(overrides).reduce((acc, [key, value]) => {
                acc[`--color-${key}`] = value as string;
                return acc;
            }, {} as Record<string, string>),
        ];
    }
    return [
        {
            ...theme,
            colors: {
                ...theme.colors,
                [theme.colorMode]: {
                    ...theme.colors[theme.colorMode],
                    ...overrides,
                },
            },
        },
        {},
    ];
};
